import { render, staticRenderFns } from "./CompanyIntroScreen.vue?vue&type=template&id=21c8d50c&"
import script from "./CompanyIntroScreen.vue?vue&type=script&lang=js&"
export * from "./CompanyIntroScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports